// extracted by mini-css-extract-plugin
module.exports = {"searchSkeleton":"SearchSkeleton_searchSkeleton__ZUqq3"};